<template>
  <reg-async-selector :ref="inputRef"
                      v-model="fieldValue"
                      v-bind="field"
                      :read-only="field.readOnly || readOnly"
                      :box="box || field.box"
                      :required="maybeCall(field.required, value)"
                      :rules="validationRules"
                      @input="fieldChanged" />
</template>

<script>
import { defineComponent, toRef } from 'vue'
import { useDynamicField } from '../composables/useDynamicField'
import AsyncSelector from '~shared/selectors/AsyncSelector.vue'

export default defineComponent({
  name: 'DynamicAsyncSelector',
  components: {
    'reg-async-selector': AsyncSelector
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    field: {
      type: Object,
      required: true
    },
    readOnly: {
      type: Boolean,
      default: false
    },
    box: {
      type: Boolean,
      default: false
    },
    small: {
      type: Boolean,
      default: false
    },
    isValidating: {
      type: Boolean,
      default: false
    },
    itemKey: {
      type: String,
      default: ''
    }
  },
  emits: ['input', 'change'],
  setup(props, { emit, expose }) {
    const {
      fieldValue,
      validationRules,
      inputRef,
      maybeCall,
      fieldChanged,
      hasError
    } = useDynamicField({
      value: toRef(props, 'value'),
      field: props.field,
      readOnly: props.readOnly,
      isValidating: toRef(props, 'isValidating'),
      itemKey: props.itemKey,
      emptyValue: '',
      emit
    })

    // Expose properties for DynamicForm validation
    expose({
      hasError,
      validate: () => inputRef.value?.validate?.()
    })

    return {
      fieldValue,
      validationRules,
      maybeCall,
      fieldChanged,
      inputRef
    }
  }
})
</script>